module.exports = __webpack_public_path__ + "images/c969ed091856935d401eaa2661ed65bb.svg";